import React, { Component } from 'react';
import Paper from 'material-ui/Paper';

class TenantPets extends Component {
  avatarStyle = url => {
    return {
      height: '120px',
      width: '120px',
      float: 'right',
      border: '0px solid #e1e1e1',
      boxShadow: 'none',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      marginRight: '20px',
      backgroundPosition: '50% 0',
      backgroundImage: 'url(' + url + ')',
    };
  };

  render() {
    const style = {
      header: {
        color: '#4e4e4e',
        fontSize: '18px',
        marginBottom: '0',
        marginTop: '0',
      },
      sub_header: {
        marginTop: '5px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
      },
      subMenuHeader: {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      },
    };

    let tenantPets = this.props.pets || [];

    if (tenantPets.length !== 0) {
      tenantPets = tenantPets.map((tenantPet, index) => (
        <div key={index} className="row">
          <div className="wrapper">
            <div className="col-sm-6">
              <Paper circle={true} style={this.avatarStyle(tenantPet.avatar)} zDepth={1} />
            </div>
            <div className="col-sm-6" style={{ paddingTop: '20px' }}>
              <h5 style={style.header}>
                <b>{tenantPet.name}</b>
              </h5>
              <h5 style={style.sub_header}>
                Breed <b>{tenantPet.breed}</b>
              </h5>
              <h5 style={style.sub_header}>
                Weight <b>{tenantPet.weight} lbs</b>
              </h5>
              <h5 style={style.sub_header}>
                Age <b>{tenantPet.age} Years Old</b>
              </h5>
              <h5 style={style.sub_header}>
                Markings <b>{tenantPet.distinctive_markings}</b>
              </h5>
              <h5 style={style.sub_header}>
                Service Animal <b>{tenantPet.service_animal ? 'Yes' : 'No'}</b>
              </h5>
              {tenantPet.city_license_number && (
                <h5 style={style.sub_header}>
                  License Number <b>{tenantPet.city_license_number}</b>
                </h5>
              )}
            </div>
          </div>
        </div>
      ));
    } else {
      tenantPets = (
        <div style={{ textAlign: 'center' }}>
          <small>No Pets.</small>
        </div>
      );
    }

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Tenant Pets </h5>
        </div>

        {tenantPets}
      </div>
    );
  }
}

export default TenantPets;
